class RuyiInkHome {
  constructor(root) {
    this.root = root;
    this.video = root.querySelector('.ruyi-ink-hero__video');
    this.toggle = root.querySelector('[data-ruyi-video-toggle]');
    this.reveals = [...root.querySelectorAll('[data-ruyi-reveal]')];
    this.bindVideo();
    this.bindReveal();
    this.bindNavigation();
    this.bindMobileMenu();
  }

  bindVideo() {
    if (!this.video || !this.toggle) return;

    this.toggle.addEventListener('click', () => {
      if (this.video.paused) {
        this.video.play();
        this.toggle.textContent = 'Pause';
        this.toggle.setAttribute('aria-label', 'Pause background video');
      } else {
        this.video.pause();
        this.toggle.textContent = 'Play';
        this.toggle.setAttribute('aria-label', 'Play background video');
      }
    });
  }

  bindReveal() {
    if (!('IntersectionObserver' in window)) {
      this.reveals.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.14 }
    );

    this.reveals.forEach((item) => observer.observe(item));
  }

  bindMobileMenu() {
    const menu = this.root.querySelector('.ruyi-ink-menu');
    if (!menu) return;
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
  }

  bindNavigation() {
    const links = [...this.root.querySelectorAll('.ruyi-ink-nav a')];
    links.forEach((link) => {
      link.addEventListener('click', () => {
        links.forEach((item) => item.classList.remove('is-active'));
        link.classList.add('is-active');
      });
    });
  }
}

const initializeRuyiInkHome = () => {
  document.querySelectorAll('.ruyi-ink-home').forEach((root) => {
    if (root.dataset.ruyiInitialized === 'true') return;
    root.dataset.ruyiInitialized = 'true';
    new RuyiInkHome(root);
  });
};

document.addEventListener('DOMContentLoaded', initializeRuyiInkHome);
document.addEventListener('shopify:section:load', initializeRuyiInkHome);
